import React, { useContext } from "react";
import { Box, Switch, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { ModuleContext } from "../utils/Constants";
import { isComponentDisabled, isComponentVisible } from "../utils/SaitUtils";
import PropTypes from "prop-types";

SaitSwitch.propTypes = {
	value: PropTypes.bool,
	onChange: PropTypes.func,
	startLabel: PropTypes.string,
	endLabel: PropTypes.string,
	hidden: PropTypes.bool,
	disabled: PropTypes.bool,
	objmod: PropTypes.any,
	sx: PropTypes.object,
};

/**
 * @param {{
 *  value: boolean,
 *  onChange: (checked: boolean) => void,
 *  startLabel?: string,
 *  endLabel?: string,
 *  hidden?: boolean,
 *  disabled?: boolean,
 *  objmod?: any,
 *  sx?: object
 * }} props
 */
export default function SaitSwitch(props) {
	const componentModule = useContext(ModuleContext);
	const objModArray = useSelector((state) => state["auth"]["objMod"]);
	const objMod = objModArray.find((objModObject) => objModObject.moduleName === componentModule && objModObject.idObject === props.objmod);

	const handleChange = (event) => {
		props.onChange(event.target.checked);
	};

	return isComponentVisible(objMod, props.hidden) ? (
		<Box
			sx={{
				...props.sx,
				display: "inline-flex",
				alignItems: "center",
				justifyContent: "center",
			}}
		>
			<Typography>{props.startLabel}</Typography>
			<Switch checked={props.value} onChange={handleChange} disabled={isComponentDisabled(objMod, props.disabled)} />
			<Typography>{props.endLabel}</Typography>
		</Box>
	) : null;
}
